import { useEffect, useState } from "react";
import { Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import { api } from "./lib/api";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Setup from "./pages/Setup";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import Import from "./pages/Import";
import Templates from "./pages/Templates";
import Send from "./pages/Send";
import SendLog from "./pages/SendLog";

type AuthState = "loading" | "needs_setup" | "needs_login" | "authed";

export default function App() {
  const [auth, setAuth] = useState<AuthState>("loading");
  const nav = useNavigate();
  const loc = useLocation();

  async function refreshAuth() {
    try {
      const s = await api<{ setupComplete: boolean; authenticated: boolean }>("/api/auth/status");
      if (!s.setupComplete) setAuth("needs_setup");
      else if (!s.authenticated) setAuth("needs_login");
      else setAuth("authed");
    } catch {
      setAuth("needs_login");
    }
  }
  useEffect(() => { refreshAuth(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  useEffect(() => {
    if (auth === "needs_setup" && loc.pathname !== "/setup") nav("/setup", { replace: true });
    if (auth === "needs_login" && loc.pathname !== "/login") nav("/login", { replace: true });
    if (auth === "authed" && (loc.pathname === "/login" || loc.pathname === "/setup")) {
      nav("/", { replace: true });
    }
  }, [auth, loc.pathname, nav]);

  if (auth === "loading") {
    return <div className="flex h-screen items-center justify-center text-slate-500">Loading…</div>;
  }

  return (
    <Routes>
      <Route path="/setup" element={<Setup onDone={refreshAuth} />} />
      <Route path="/login" element={<Login onDone={refreshAuth} />} />
      <Route element={<Layout onLogout={refreshAuth} />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/import" element={<Import />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/send" element={<Send />} />
        <Route path="/log" element={<SendLog />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
